// extracted by mini-css-extract-plugin
export default {"wrapper":"gReUjpW9nS","label":"d9p6Jt84po","inner":"hgaqTWd3nH","group":"iN8MADxWR2","input":"WvJfBuAabA","hexInput":"S43YK8UysV","dark":"eXK14V2ceb"};